<template>
  <div class="group-box" v-if="pink" :style="{ marginBottom: (pink.isLeader || pink.isJoin ? '10px' : '75px') }">
    <!-- 弹幕 -->
    <BulletScreen />
    <!-- 课程信息 -->
    <div class="subject" @click="toAnchor('#tabContent0')" v-if="pink.subject">
      <div class="cover-box">
        <van-image class="cover" :src="pink.subject.smallLogoImg" show-error show-loading />
      </div>
      <div class="info-box">
        <div class="title">{{ pink.subject.title }}</div>
        <div class="labels">
          <div class="label item-number">{{ pink.subject.itemNum }}集</div>
          <div class="label age-group">{{ pink.subject.ageGroup }}岁</div>
          <div class="label">{{ pink.subject.groupNum }}人成团</div>
        </div>
        <div class="bottom">
          <div class="price">
            <div class="group-price">¥ {{ pink.subject.groupPrice }}</div><div class="full-price">¥ {{ pink.subject.fullPrice }}</div>
          </div>
          <div class="attended">
            已有{{ pink.subject.pinkSalesNum  }}人参与学习
          </div>
        </div>
      </div>
    </div>
    <!-- 拼团中 -->
    <div class="detail">
      <div class="title">拼团仅差<span>{{ pink.needNum }}</span>人，快和大家一起来学习</div>
      <!-- 倒计时 -->
      <div class="count-down">
        离结束
        <van-count-down :time="pink.countDownSecond * 1000" @finish="countDownFinish" millisecond>
          <template v-slot="timeData">
            <span class="item">{{ timeData.days * 24 + timeData.hours }}</span>
            <span class="line">：</span>
            <span class="item">{{ timeData.minutes }}</span>
            <span class="line">：</span>
            <span class="item">{{ timeData.seconds }}</span>
            <span class="line">：</span>
            <span class="item">{{ parseInt(timeData.milliseconds / 100) }}</span>
          </template>
        </van-count-down>
      </div>

      <!-- 参与拼团的人 -->
      <div class="members">
        <div class="item active" v-for="(pinkedUser, index) in pink.users" :key="index">
          <img :src="pinkedUser.avatar ? pinkedUser.avatar : require('@/assets/icons/none.png')" />
          <span class="leader-label" v-if="index===0">团长</span>
        </div>
        <div class="item" v-for="index in pink.needNum" :key="index">
          <img :src="require('@/assets/icons/none.png')" />
        </div>
      </div>

      <!-- 按钮 -->
      <div class="invite-btns relative-button" id="inviteBtns">
        <!-- 未加入此拼团时显示参与拼团 -->
        <button class="invite-common invite" @click="showSheet=true">¥ {{ pink.subject.groupPrice }} {{pink.subject.groupPrice > 0 ? '立即参团' : '免费领取'}}</button>
        <button v-if="!user.isOneRmbTry && !user.isBuySubject && !pink.subject.isSingle" class="invite-common piolt" @click="navToEarlyAccess">1元体验</button>
        <button v-else class="invite-common piolt" @click="toAnchor('#subjectSwipe')">课程详情</button>
      </div>

      <!-- 退款提示 -->
      <div class="refund-box">
        <div class="refund-tip">提示：拼团人数不足，自动退款</div>
      </div>
    </div>

    <!-- 课程详情 -->
    <SubjectDetail :subject="pink.subject" v-if="pink.subject" />

    <div class="invite-btns fix-button" v-show="showBottomButton">
      <!-- 未加入此拼团时显示参与拼团 -->
      <button class="invite-common invite" @click="showSheet=true">¥ {{ pink.subject.groupPrice }} {{pink.subject.groupPrice > 0 ? '立即参团' : '免费领取'}}</button>
      <button v-if="!user.isOneRmbTry && !user.isBuySubject" class="invite-common piolt" @click="navToEarlyAccess">1元体验</button>
      <button v-else class="invite-common piolt" @click="toAnchor('#subjectSwipe')">课程详情</button>
    </div>

    <!-- 购买弹窗 -->
    <van-action-sheet v-model="showSheet" class="pay_box" title="课程详情" @close="cancelConfirm()" :close-on-click-overlay="false">
      <div class="shop_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/goods.png')" />
        </div>
        <div class="text fl">课程名称</div>
        <div class="name fr">{{ pink.subject.title }}</div>
      </div>
      <div class="buyway_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/buyway.png')" />
        </div>
        <div class="text fl">购买方式</div>
        <div class="name fr">拼团购买</div>
      </div>
      <div class="pay_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/pay.png')" />
        </div>
        <div class="text fl">支付总额</div>
        <div class="name fr"><span>￥</span><span class="num">{{ pink.subject.groupPrice }}</span></div>
      </div>
      <button class="sure_pay" @click="sendOrder">确定支付</button>
    </van-action-sheet>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import SubjectDetail from '@/pages/subject/detail'
import { createOrder, getOrderInfo, getPinkInfoAndUserInfo } from './query.gql'
import BulletScreen from '@/components/BulletScreen'
export default {
  name: 'group',
  data() {
    return {
      user: '', // 用户信息
      pink: '', // 拼团信息
      showSheet: false, // 显示购买弹框
      showBottomButton: false // 显示邀请相关按钮
    }
  },
  components: {
    SubjectDetail,
    BulletScreen
  },
  async mounted() {
    console.log('拼团进行页')
    await this.weixinAuth()
    this.loadInformations() // 获取拼团信息
    window.addEventListener('scroll', this.groupPageScroll)
  },
  methods: {
    groupPageScroll(e) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let inviteBtnsBottom = this.$el.querySelector('#inviteBtns').offsetTop + this.$el.querySelector('#inviteBtns').offsetHeight
      // 判断邀请按钮下部位置是否比页面顶部位置要小
      if (scrollTop > inviteBtnsBottom) {
        this.showBottomButton = true
      } else {
        this.showBottomButton = false
      }
    },
    loadInformations() {
      let self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.loadPinkInfo(self.$route.params.id).then(res => {
        self.user = res.data.profile
        self.pink = res.data.pink
        self.pink.needNum = self.pink.peopleNum - self.pink.users.length // 计算拼团成功还需人数
        if (self.pink.status === 'success') {
          window.location.replace(`${window.location.origin}/?#/group/${self.pink.id}/success`)
        } else if (self.pink.status === 'fail') {
          window.location.replace(`${window.location.origin}/?#/group/${self.pink.id}/fail`)
        }
        self.setShare()
        self.$toast.clear()
      }).catch(err => {
        self.$toast.clear()
        console.error('page: group/index。请求getPinkInfo报错', err)
      })
    },
    setShare() {
      const self = this
      let title = self.pink.needNum > 0 ? `仅差${self.pink.needNum}人!${self.pink.subject.pinkShareTitle}` : self.pink.subject.pinkShareTitle
      // 设置分享
      self.wechatShare({
        title: title,
        imgUrl: self.pink.subject.smallLogoImg,
        desc: self.pink.subject.pinkShareContent,
        link: `${window.location.origin}/?#/group/${self.pink.id}/share`
      })
    },
    // 获取拼团信息和用户信息
    loadPinkInfo(id) {
      return this.$apollo.query({
        query: getPinkInfoAndUserInfo,
        variables: {
          id: parseInt(id)
        },
        fetchPolicy: 'no-cache'
      })
    },
    // 倒计时结束
    countDownFinish() {
      this.$router.replace({
        name: 'groupFail',
        params: { id: this.pink.id }
      })
    },
    // 跳转1元体验7天页面
    navToEarlyAccess() {
      this.$router.push({
        name: 'earlyAccess'
      })
    },
    // 取消确认
    cancelConfirm() {
      const self = this
      console.log('showSheet', self.showSheet)
      if (self.showSheet) {
        self.$dialog.confirm({
          message: '确认取消付款？',
          confirmButtonText: '继续支付',
          confirmButtonColor: '#ff4e00',
          cancelButtonText: '取消支付'
        }).then(() => {
          self.showSheet = true
        }).catch(() => {
          this.shopSheet = false
          console.log('TODO: 取消订单')
        })
      }
    },
    toAnchor(selector) {
      const anchor = this.$el.querySelector(selector)
      scroll(0, anchor.offsetTop)

      // const self = this
      // self.$zhuge.track('课程详情或试看', {
      //   '课程名称': self.pink.subject.title,
      //   '动作标识': selector
      // })
    },
    // 下单
    sendOrder() {
      const self = this
      if (self.pink.isJoin || self.pink.isBuySubject || self.pink.hasOngoingPink) {
        self.$toast.fail('已购买此课程')
        console.log('已购买此课程,不能下单,跳转')
        return
      }
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '提交中'
      })
      // 用户未购买此课程
      let variables = {
        subjectId: self.pink.subject.id,
        types: 'pink_buy',
        pinkId: self.pink.id
      }
      console.log('下单参数', variables)

      self.$apollo.mutate({
        mutation: createOrder,
        variables
      }).then(res => {
        console.log('下单结果', res)
        let result = res.data.createOrderMutation
        if (result.order.totalFee > 0) {
          self.wechatPay().then(() => {
            wx.chooseWXPay({
              timestamp: result.timeStamp,
              nonceStr: result.nonceStr,
              package: result.package,
              signType: result.signType,
              paySign: result.paySign,
              success() {
                self.$toast.clear()
                self.polling(result.order.tranNo)

                // self.$zhuge.track('跟团购买', {
                //   '课程名称': self.pink.subject.title
                // })
              },
              cancel() {
                self.$toast.clear()
                self.$toast('支付已取消')
                // 设置分享
                self.setShare()
              },
              fail() {
                self.$toast.clear()
                self.$toast.fail('支付失败')
                // 设置分享
                self.setShare()
              }
            })
          })
        } else {
          self.$toast.clear()
          self.polling(result.order.tranNo)
        }
      }).catch(err => {
        self.$toast.clear()
        self.$toast.fail(err.graphQLErrors[0].message || '下单失败')
        console.error('page: group/index。请求createOrder报错', err)
      })
    },
    // 轮询
    polling(tranNo) {
      console.log()
      const self = this
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '支付中'
      })
      self.showSheet = false

      let pollTimes = self.$consts.POLLING_TIMES || 5 // 默认轮询五次
      let timer = setInterval(() => {
        pollTimes -= 1
        if (pollTimes >= 0) {
          self.$apollo.query({
            query: getOrderInfo,
            variables: { tranNo },
            fetchPolicy: 'no-cache'
          }).then(res => {
            console.log('支付后', res)
            if (res.data.order.status === 'paid') {
              self.$toast.clear()
              clearInterval(timer)
              self.$router.replace({
                name: res.data.order.pink.peopleNum === res.data.order.pink.users.length ? 'groupSuccess' : 'groupInvite',
                params: { id: res.data.order.pink.id }
              })
            }
          }).catch(err => {
            console.error('page: group/index。（轮询）请求getOrderInfo报错', err)
          })
        } else {
          // 超过5次轮询没有结果怎么办？？
          self.$toast.clear()
          // 设置分享
          self.setShare()
        }
      }, self.$consts.POLLING_INTERVAL || 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
.group-box {
  .subject {
    display: flex;
    padding-left: 20px;
    padding-top: 20px;
    padding-right: 8px;
    .cover-box {
      .cover {
        width: 95px;
        height: 95px;
        border-radius: 10px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .info-box {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 16px;
      .title {
        font-size: 18px;
        font-weight: bold;
      }
      .labels {
        display: flex;
        flex-direction: row;
        .label {
          font-size: 14px;
          background: #ffddcd;
          color: #ff771d;
          padding: 2px 12px;
          border-radius: 24px;
          text-align: center;
        }
        .item-number {
          margin-right: 8px;
        }
        .age-group {
          margin-right: 8px;
        }
      }
      .bottom {
        width: 100%;
        line-height: 24px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
        .price {
          display: flex;
          flex-direction: row;
          align-items: baseline;
          .group-price {
            font-size: 20px;
            color: #fa512d;
            font-weight: bold;
          }
          .full-price {
            margin-left: 6px;
            font-size: 16px;
            color: #666666;
            text-decoration: line-through;
          }
        }
        .attended {
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }

  .pink-success, .pink-fail, .detail {
    background: #fff;
    padding-bottom: 20px;
    .title {
      font-size: 17.5px;
      color: #333;
      padding: 20px 0 15px;
      font-weight: bold;
      text-align: center;
      letter-spacing: 2px;
      span {
        color: #fa512d;
        font-size: 21px;
        font-weight: bold;
      }
    }
    .count-down {
      font-size: 14px;
      padding-bottom: 17px;
      color: #4d4d4d;
      font-weight: bold;
      text-align: center;
      .van-count-down{
        display: inline;
        .item{
          color: #fff;
          display: inline-block;
          width: 27px;
          height: 27px;
          line-height: 27px;
          box-sizing: border-box;
          text-align: center;
          background-color: #666;
          border-radius: 5px;
        }
        .line{
          margin-left: 5px;
        }
      }
    }
    .members {
      overflow: hidden;
      padding-bottom: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      .leader-label {
        width: 30px;
        font-size: 12px;
        background: #ffddcd;
        color: #ff771d;
        padding: 0px 10px;
        border-radius: 20px;
        text-align: center;
        position: absolute;
        left: 0px;
        bottom: -2px;
      }
      .item {
        width: 50px;
        height: 50px;
        margin-right: 17.5px;
        padding: 2.5px;
        box-sizing: border-box;
        margin-top: 6px;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        &.active {
          background: url('~@/assets/images/groupUserHasPayBg.png') no-repeat center / 100%;
        }
      }
    }

    .poster {
      padding-bottom: 14px;
      text-align: center;
      span {
        border-bottom: 1px solid #ff623b;
        font-size: 12.5px;
        line-height: 17.5px;
        color: #ff623b;
      }
    }
  }
  .fix-button {
    position: fixed;
    left: 30%;
    bottom: 0px;
  }
  .relative-button {
    position: relative;
  }
  .invite-btns {
    height: 46.5px;
    padding-bottom: 7.5px;
    .invite-common {
      font-size: 16px;
      height: 42.5px;
      width: 146px;
      line-height: 46.5px;
      font-weight: bold;
      text-align: center;
      margin: 0 auto;
      border-radius: 25px;
      color: #fff;
      position: absolute;
      /*background: linear-gradient(to top, #ff4800,#ff9600);*/
      background: #ff4800;
      /*box-shadow: 0 0 8px #ff8f00;*/
      border: none;
      outline: none;
      cursor: pointer;
      -webkit-appearance: none;
      animation: pulse 1s infinite;
      position: relative;
    }
    .invite {
      left: 50%;
      margin-left: -165px;
    }
    .piolt {
      left: 50%;
      margin-left: 32px;

      background: #fff;
      border: 1px solid #fa512d;
      color: #fa512d;
      /*box-shadow: none;*/
    }
  }

  .refund-box {
    padding-bottom: 7.5px;
    .refund-tip {
      text-align: center;
      font-size: 14px;
      color: #666;
    }
  }

  .invite-alert {
    .title {
      display: flex;
      justify-content: center;
      font-size: 28px;
      line-height: 40px;
      padding: 0 10px;
      box-sizing: border-box;
      text-align: center;
      color: #333;
      font-weight: bold;
      margin: 10px 0;
      .line {
        margin: 18px 20px;
        height: 2px;
        width: 50px;
        background: #2d3335;
      }
    }
    .content {
      margin: 0 15px;
      padding: 12px 17px;
      background: #f5f6f9;
      color: #666;
      line-height: 24px;
    }
    .extend {
      display: flex;
      justify-content: center;
      margin: 17px auto;
      img {
        height: 30px;
        display: inline-block;
        vertical-align: bottom;
        pointer-events: none;
      }
      span {
        margin-top: 5px;
        font-size: 18px;
        color: #2d3335;
        font-weight: 550;
      }
    }
  }

  .btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    .full {
      flex: 1;
      padding: 8px 0;
      background-color: #ff7639;
      text-align: center;
    }
    .group {
      width: 58%;
      padding: 8px 0;
      background-color: #ff4e00;
      box-sizing: border-box;
      text-align: center;
      overflow: hidden;
      .limit {
        color: #fa512d;
        background-color: #ff0;
        position: absolute;
        width: 120px;
        height: 48px;
        line-height: 80px;
        font-size: 18px;
        top: -15px;
        right: -50px;
        font-weight: bold;
        text-align: center;
        transform: rotate(40deg);
      }
    }
    .price {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .normal-btn-box {
    display: flex;
    color: #fff;
    overflow: hidden;
    box-sizing: border-box;
    padding-top: 20px;
    padding-bottom: 20px;
    .full {
      flex: 1;
      padding: 8px 0;
      background-color: #ff7639;
      text-align: center;
      margin: 0 15px;
      border-radius: 28px;
    }
    .group {
      width: 45%;
      background-color: #ff4e00;
      box-sizing: border-box;
      text-align: center;
      overflow: hidden;
      padding: 8px 0;
      margin: 0 15px;
      border-radius: 28px;
      position: relative;
      .limit {
        color: #fa512d;
        background-color: #ff0;
        position: absolute;
        width: 120px;
        height: 40px;
        line-height: 60px;
        top: -6px;
        right: -45px;
        font-weight: bold;
        text-align: center;
        transform: rotate(40deg);
      }
    }
    .price {
      font-size: 20px;
      font-weight: bold;
    }
  }

  // .subject-detail-box {
  //   margin-bottom: 56px;
  // }

  .pay_box {
    font-size: 15.36px;
    border-radius: 9.6px 9.6px 0 0;
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    img {
      width: 100%;
    }
    .tab {
      overflow: hidden;
      height: 38.3906px;
      line-height: 38.3906px;
      padding: 0 26.88px;
      border-bottom: 0.46875px solid #f7f7f7;
      .img {
        padding-top: 9.6px;
        padding-right: 12.48px;
        width: 18.7188px;
      }
      .text {
        font-size: 17.28px;
        color: #333;
      }
      .name {
        font-size: 14.4px;
        color: #666;
        padding-right: 4.8px;
      }
    }
    .sure_pay {
      display: block;
      margin: 0 auto 22.56px;
      width: 92%;
      height: 45.1094px;
      border-radius: 22.56px;
      line-height: 45.12px;
      font-size: 18.72px;
      color: #fff;
      text-align: center;
      background-color: #ff6000;
      margin: 15.36px 14.4062px 24px;
    }
    .sure_pay {
      display: block;
      margin: 0 auto 22.56px;
      width: 92%;
      height: 45.1094px;
      border-radius: 22.56px;
      line-height: 45.12px;
      font-size: 18.72px;
      color: #fff;
      text-align: center;
      background-color: #ff6000;
      margin: 15.36px 14.4062px 24px;
      border: unset;
    }
  }
}
</style>
